export const USEFUL_LINKS_QUERY_PARAM = 'usefullLink';

const toSearchParams = (search: string = '') => new URLSearchParams(search);

const toSearchString = (params: URLSearchParams) => {
    const value = params.toString();
    return value ? `?${value}` : '';
};

export const isUsefulLinksPopupQueryOpen = (search: string = '') =>
    toSearchParams(search).get(USEFUL_LINKS_QUERY_PARAM) === 'true';

export const withUsefulLinksPopupQuery = (search: string = '') => {
    const params = toSearchParams(search);
    params.set(USEFUL_LINKS_QUERY_PARAM, 'true');
    return toSearchString(params);
};

export const withoutUsefulLinksPopupQuery = (search: string = '') => {
    const params = toSearchParams(search);
    params.delete(USEFUL_LINKS_QUERY_PARAM);
    return toSearchString(params);
};

export const shouldOpenUsefulLinksPopupFromQuery = (
    isQueryOpen: boolean,
    alreadyOpenedForCurrentQuery: boolean
) => isQueryOpen && !alreadyOpenedForCurrentQuery;
